import rill from "rill";
import ensureAdmin from "../../middleware/ensure-admin";
import ensureUser from "../../middleware/ensure-user";
import exerciseLibraryController from "./exercise-library/exercise-library-controller";
import importMealPlanController from "./import-meal-plan/import-meal-plan-controller";
import importProgramController from "./import-program/import-program-controller";
import newsController from "./news.controller";
import Reports from "./reports";
import tutorialCategoryController from "./tutorials/tutorial-category.controller";
import Users from "./users";

const Admin = (app) => {
  app.at(
    "/admin/*",
    ensureUser,
    ensureAdmin,
    rill()
      .setup(Users)
      .setup(Reports)
      .setup(exerciseLibraryController)
      .setup(tutorialCategoryController)
      .setup(newsController)
      .setup(importProgramController)
      .setup(importMealPlanController)
  );
};

export default Admin;
